import styled from "styled-components";

export type AlertType = {
    visibility: "hidden" | "visible",
    opacity: 0 | 1
}

export const SAlert = styled.div<AlertType>`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    transition: opacity 500ms;
    visibility: ${props => props.visibility};
    opacity: ${props => props.opacity};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 200;
    

    article {
        padding: 1.25rem;
        background: #fff;
        border-radius: 0.3rem;
        width: 40%;
        position: relative;
        transition: all 0.5s ease-in-out;
        max-width: 26rem;

        @media screen and (max-width: 700px) {
            width: 90%;
            max-width: 90%;
        }

        .title {
            display: flex;
            justify-content: flex-end;
            align-items: center;


            button {
                transition: all 200ms;
                font-size: 1.875rem;
                font-weight: bold;
                text-decoration: none;
                color: ${props => props.theme.colors.primary};
                background-color: #fff;
                cursor: pointer;
                border: none;

                &:hover {
                    color: ${props => props.theme.colors.tertiary};
                }
            }
        }

        .content {
            font-size: 1rem;
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            p{
                text-align: center;
            }

            button{
                height: 4rem;
                padding: 0 2.1rem;
                background: ${props => props.theme.colors.tertiary};
                border: 1px solid ${props => props.theme.colors.white};
                cursor: pointer;
                border-radius: 10rem;
                color: ${props => props.theme.colors.white};
                font-weight: bold;
                font-size: 0.85rem;
                transition: all 0.5s ease;
                width: 10rem;
                margin-top: 1.5rem;
                font-size: 1rem;
                &:hover{
                    transform: translateY(-0.5rem);
            }
         }
            
        }
    }   
`